import { ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  HeatingConfigurationSecondaryHeatGeneratorModeOnErrorCommand,
  HeatingConfigurationSecondaryHeatGeneratorModeOnErrorProperties,
  HeatingConfigurationSecondaryHeatGeneratorModeOnErrorValue,
  HeatingRodHeatingCommands,
  HeatingRodHeatingProperties,
  HeatingRodStatisticsProperties,
  HeatingRodStatusProperties,
  IsNumberValueProperty,
} from '@vi-iot/client';

import { AuthStore, Helpers, InstallationFeaturesStore } from '@store';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-electric-heater-overlay',
  templateUrl: './electric-heater-overlay.component.html',
  styleUrls: ['./electric-heater-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectricHeaterOverlayComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  readonly featurePropertyKey = FeaturePropertyKey;
  readonly featureCommands = FeatureCommands;
  readonly heatingConfigurationSecondaryHeatGeneratorModeOnErrorValue = HeatingConfigurationSecondaryHeatGeneratorModeOnErrorValue;
  getHeatingRodStatusValue = Helpers.getHeatingRodStatusValue;
  heatingRodHeating$: Observable<Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>>;
  heatingRodDhw$: Observable<Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>>;
  heatingRodStatus$: Observable<Feature<HeatingRodStatusProperties, never>>;
  heatingRodStatistics$: Observable<Feature<HeatingRodStatisticsProperties, never>>;
  heatingRodMaximumOutsideTemperature$: Observable<Feature<IsNumberValueProperty, never>>;
  heatingConfigurationDhwHeater$: Observable<
    Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>
  >;
  heatingConfigurationSecondaryHeatGeneratorModeOnError$: Observable<
    Feature<
      HeatingConfigurationSecondaryHeatGeneratorModeOnErrorProperties,
      HeatingConfigurationSecondaryHeatGeneratorModeOnErrorCommand
    >
  >;

  constructor(
    public authStore: AuthStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.heatingRodHeating$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodHeating
    );
    this.heatingRodDhw$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodDhw
    );
    this.heatingRodStatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodStatus
    );

    this.heatingRodStatistics$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodStatistics
    );

    this.heatingRodMaximumOutsideTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodMaximumOutsideTemperature
    );

    this.heatingConfigurationDhwHeater$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingConfigurationDhwHeater
    );

    this.heatingConfigurationSecondaryHeatGeneratorModeOnError$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingConfigurationSecondaryHeatGeneratorModeOnError
    );
  }

  onHeatingRodHeatingChange(value: boolean): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.heatingRodHeating,
      value,
      this.featurePropertyKey.useApproved,
      '',
      value ? FeatureCommands.grant : FeatureCommands.revoke
    );
  }

  onHeatingRodDhwChange(value: boolean): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.heatingRodDhw,
      value,
      this.featurePropertyKey.useApproved,
      '',
      value ? FeatureCommands.grant : FeatureCommands.revoke
    );
  }

  onHeatingConfigurationDhwHeaterChange(value: boolean): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.heatingConfigurationDhwHeater,
      value,
      this.featurePropertyKey.useApproved,
      '',
      value ? FeatureCommands.grant : FeatureCommands.revoke
    );
  }

  onHeatingConfigurationSecondaryHeatGeneratorModeOnErrorChange(value: MatSlideToggleChange): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.heatingConfigurationSecondaryHeatGeneratorModeOnError,
      value.checked
        ? HeatingConfigurationSecondaryHeatGeneratorModeOnErrorValue.normal
        : HeatingConfigurationSecondaryHeatGeneratorModeOnErrorValue.reduced,
      this.featurePropertyKey.mode,
      this.featurePropertyKey.mode,
      FeatureCommands.setMode
    );
  }
}
